import { IMPORT_OUTCOME, type ImportOutcome, PO_STATUS, type PoStatus } from '@/types/poTracker';
import type { AttentionTone, ShipmentState } from '@/utils/poTracker';

// One palette for every tracker pill, used with the global `.badge` class.
const TONE = {
  red: 'bg-red-50 text-red-700',
  green: 'bg-green-50 text-green-700',
  gray: 'bg-gray-100 text-gray-600',
  amber: 'bg-amber-50 text-amber-800',
  blue: 'bg-blue-50 text-blue-700',
} as const;

export const PO_STATUS_TONE: Record<PoStatus, string> = {
  [PO_STATUS.LATE]: TONE.red,
  [PO_STATUS.SHIPPED]: TONE.green,
  [PO_STATUS.NOT_PLANNED]: TONE.gray,
  [PO_STATUS.PARTLY_PLANNED]: TONE.amber,
  [PO_STATUS.PLANNED]: TONE.blue,
};

export const IMPORT_OUTCOME_TONE: Record<ImportOutcome, string> = {
  [IMPORT_OUTCOME.SKIPPED_UNKNOWN_PO]: TONE.gray,
  [IMPORT_OUTCOME.SKIPPED_HAS_SHIPMENTS]: TONE.gray,
  [IMPORT_OUTCOME.NEEDS_DATE]: TONE.amber,
  [IMPORT_OUTCOME.NEEDS_LINES]: TONE.amber,
  [IMPORT_OUTCOME.OVER_ORDER]: TONE.red,
  [IMPORT_OUTCOME.SHIPPED_MISSING]: TONE.amber,
  [IMPORT_OUTCOME.RESOLVED]: TONE.green,
};

// The tooltip on an import row's outcome badge: what it means and what to do.
export const IMPORT_OUTCOME_HELP: Partial<Record<ImportOutcome, string>> = {
  [IMPORT_OUTCOME.NEEDS_LINES]:
    'The sheet names a product family, a classification no line has, several matching lines, or no whole quantity. Tick the lines that ship and how many.',
  [IMPORT_OUTCOME.OVER_ORDER]: "The sheet's quantity is more than what is left to plan on the matched lines. Lower the line quantities or pick different lines.",
};

export const ATTENTION_TONE_TEXT: Record<AttentionTone, string> = {
  ask: 'text-violet-700',
  late: 'text-red-700',
  warn: 'text-amber-800',
};

export const SHIPMENT_STATE_TONE: Record<ShipmentState, string> = {
  planned: TONE.blue,
  late: TONE.red,
  shipped: TONE.green,
};

// "+ Plan a shipment" / "+ Add another shipment".
export const DASHED_BUTTON =
  'rounded-lg border border-dashed border-blue-400 px-3 py-1.5 text-sm font-semibold text-blue-700 transition-colors duration-150 ease-out hover:bg-blue-50';

// The × that takes a card off a form.
export const REMOVE_BUTTON = 'ml-auto rounded px-1.5 text-gray-400 transition-colors duration-150 ease-out hover:bg-gray-100 hover:text-gray-700';
